const emptyObject = {};

export const selectSearchState = (state) => state?.search ?? emptyObject;
